<template>
  <v-app id="inspire">
    <RomaHeader />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import RomaHeader from "./RomaHeader";

export default {
name: "RomaLayout",
  components: {
    RomaHeader
  }
}
</script>

<style lang="scss" scoped>
  .v-main {
    background: #f6f6f6 !important;
  }
</style>